import React from 'react';
import { Moon, Sun, Monitor } from 'lucide-react';
import { useTheme } from '@/hooks/useTheme';
import { Button } from '@/components/ui/Button';

export const ThemeToggle: React.FC = () => {
  const { theme, cycleTheme } = useTheme();

  const getThemeIcon = () => {
    switch (theme) {
      case 'light':
        return <Sun className="w-4 h-4" />;
      case 'dark':
        return <Moon className="w-4 h-4" />;
      case 'system':
        return <Monitor className="w-4 h-4" />;
      default:
        return <Sun className="w-4 h-4" />;
    }
  };

  const getThemeTitle = () => {
    switch (theme) {
      case 'light':
        return 'Tema claro ativo (clique para alternar)';
      case 'dark':
        return 'Tema escuro ativo (clique para alternar)';
      case 'system':
        return 'Tema do sistema ativo (clique para alternar)';
      default:
        return 'Alternar tema';
    }
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={cycleTheme}
      title={getThemeTitle()}
      className="relative p-2 text-gray-600 dark:text-slate-300 hover:text-gray-900 dark:text-slate-100 hover:bg-gray-100 dark:bg-slate-700 rounded-lg transition-colors"
    >
      {getThemeIcon()}
    </Button>
  );
};
